/**
 * useActiveJobs — polls the user's active background generation jobs.
 *
 * Mounted high in the tree (Sidebar, above the router), so it keeps polling
 * across section/tab switches — this is what lets the VP-logo badge stay live
 * and lets a finished generation surface no matter where the user navigated.
 */
import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";

export interface ActiveJob {
  id: string;
  type: string;
  status: "queued" | "generating" | "done" | "error";
  progress: number;
  resultUrls: string[];
  deepLink: string;
  errorMessage: string | null;
}

export function useActiveJobs() {
  const { data } = useQuery<{ jobs: ActiveJob[]; count: number }>({
    queryKey: ["jobs", "active"],
    queryFn: () => apiRequest("GET", "/api/jobs/active"),
    refetchInterval: 4000,
    staleTime: 0,
  });
  return { jobs: data?.jobs ?? [], count: data?.count ?? 0 };
}
